<template>
  <div style="width:100%; height: 100px">
    <custom-automation-node
      :data="data"
      color="#CD0404"
      icon="pi-clock"
      title="לקוח לא חזר לאחר חודש"
      node-type="middle"
      @remove="remove"
      style="height: 100px"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";

export default defineComponent( {
  name: "LeftScheduledNode",
  props: {
    data: {
      type: Object as PropType<Record<string, any>>,
      required: false,
    }
  },
  emits: ['remove'],
  setup(props, {emit}) {
    const remove = () => {emit('remove')}

    return {remove}
  }
})
</script>

<style scoped>

</style>
